import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { LoginService } from '../login.service';
import { CommonService } from '../Common.service';
import { JwtHelperService } from '@auth0/angular-jwt';
import { NotificationService } from '../notification.service';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {

  constructor(public router: Router, public jwtHelper: JwtHelperService, private loginService: LoginService, private commonService: CommonService, private _notificationService: NotificationService) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if(state.url.toUpperCase().includes( 'PEER-REVIEW/REVIEW-ADD-COMMENTS'))
    {
      return true;
    }
    if (!this.commonService.hasJWT()) {
      this._notificationService.showPopup("Session invalid", "Warning").then(
        x => this.loginService.Logout(this.commonService.getLoggedInUserStatus())
      );
      return false;
    }

    if (this.jwtHelper.isTokenExpired(this.commonService.getJWT())) {
      this._notificationService.showPopup("Session expired", "Warning").then(
        x => this.loginService.Logout(this.commonService.getLoggedInUserStatus())
      );
      return false;
    }
    if (state.url.toUpperCase() != '/dashboard/home'.toUpperCase() && state.url.toUpperCase() != '/edms/commondashboard'.toUpperCase()) {
      this.commonService.selectedProjectId.subscribe((data:any) => {
        if (data) {
          let user = {
            projectId: data,
            userId: this.commonService.getLoggedInUserId(),
            currentURL: state.url.substring(1)
          };
          if (user.projectId != 9999999) {
            this.loginService.ValidateCurentUserAccess(user).subscribe((data: Observable<any>|any) => {
              if (data["successCode"] === 200) {
                return true;
              }
              else {
                this._notificationService.showPopup(data["successMessage"], "Warning").then(
                  x => this.loginService.Logout(this.commonService.getLoggedInUserStatus())
                );
                return false;
              }
            });
          }
          return true;
        }
        else return false;
      });
    }

    return true;
  }
}
